// @core/api/endpoints/project/add_item_to_sprint.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  AddItemToSprintRequest,
  ItemResponse,
} from '../../../types/project';

const BASE_PATH = '/project';

/**
 * Add item to sprint
 * Assigns a project item to a sprint for sprint planning. The item must already exist in the project.
 */
export async function AddItemToSprint(
  project_id: string,
  sprint_id: string,
  data: AddItemToSprintRequest,
  options?: RequestOptions
): Promise<ItemResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/projects/:project_id/sprints/:sprint_id/items`;
  requestPath = requestPath.replace(':project_id', encodeURIComponent(project_id));
  requestPath = requestPath.replace(':sprint_id', encodeURIComponent(sprint_id));
  const requestOptions = options;
  return client.post<ItemResponse>(requestPath, data, requestOptions);
}
